<template>
  <q-btn
    v-bind="btnPropsComputed"
    class="btn-default"
    :class="btnPropsComputed?.class"
    :style="btnPropsComputed?.style"
  >
    <slot></slot>
    <q-tooltip v-if="btnPropsComputed?.tooltip">
      {{ btnPropsComputed?.tooltip }}
    </q-tooltip>
  </q-btn>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "BtnDefault",
  components: {},
  props: {
    mode: {
      type: String as PropType<"default" | "icon" | "item">,
      default: "default",
    },
    btnProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    btnPropsComputed(): any {
      return {
        noCaps: true,
        class: undefined,
        style: undefined,
        tooltip: undefined,
        label: undefined,
        ...this.modeProps[this.mode],
        ...this.btnProps,
      };
    },
  },
  data() {
    return {
      modeProps: {
        default: {
          unelevated: true,
          label: "default label",
        },
        icon: {
          flat: true,
          icon: "tag",
          tooltip: "icon tooltip",
          dense: true,
        },
        item: {
          flat: true,
          label: "item label",
          dense: false,
          class: "full-width",
          align: "left",
        },
      },
    };
  },
  watch: {},
  methods: {},
});
</script>

<style lang="scss">
.btn-default {
  .q-btn__content {
    white-space: nowrap;
    flex-wrap: nowrap;
  }
}
</style>
